import { render, staticRenderFns } from "./FugaArtists.vue?vue&type=template&id=b94c3b46&"
import script from "./FugaArtists.vue?vue&type=script&lang=js&"
export * from "./FugaArtists.vue?vue&type=script&lang=js&"
import style0 from "./FugaArtists.vue?vue&type=style&index=0&id=b94c3b46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports